export const AGGREGATOR_ORIGINAL_SOURCES_OF_DATA = ['CompareNow', 'TheZebra', 'MEDIA_ALPHA'];
export const AGGREGATOR_SOURCES_OF_ENTRY = ['MED_ALPHA'];
